export const DEVELOPMENT_STATES = {
  'in-construction': 'Propiedad en construcción',
  'operation': 'Propiedad en operación',
  'liquidated': 'Propiedad liquidada',
  'predio': 'Predio',
  'fix-rent': 'Renta fija'
};


export const DEVELOPMENT_STATES_INFO = {
  'in-construction': 'Es un inmueble que se encuentra en construcción. El solicitante otorga un “descuento por preventa”, una vez terminada la construcción pasa al modelo de propiedad en operación. ',
  'operation': 'El inmueble ya está terminado en obra y se encuentra operando. Los rendimientos que se reciben se obtienen a través de la ocupación que tengan las habitaciones adquiridas.',
  'liquidated': 'Se ha retornado la inversión total más sus dividendos generados.',
  'predio': 'Se pacta con el solicitante un pago de dividendos por un periodo establecido.',
  'fix-rent': 'Se pacta con el solicitante un pago de dividendos por un periodo establecido.'
}
